import Home from "./Index";

const AgencyReport = () => {
  return <Home title='Report based on Agency Banking' url='agency' />;
};
export default AgencyReport;
